import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { SocialNetworkRepository } from "@entity/data/repositories/social-network.repository";
import { inject, injectable } from "inversify";
import { CreateSocialNetwork } from "../../models/create-social-network.model";
import { SocialNetwork } from "../../models/social-network.model";

@injectable()
export class CreateSocialNetworkUseCase {
    constructor(
        @inject(SocialNetworkRepository)
        private readonly socialNetworkRepository: SocialNetworkRepository,
    ) {}

    async execute(
        socialNetwork: CreateSocialNetwork,
    ): Promise<Nullable<SocialNetwork>> {
        const creationResult =
            await this.socialNetworkRepository.create(socialNetwork);

        if (creationResult.isLeft()) {
            ToastManagerStore.error(creationResult.getLeftOrThrow().message);
        }

        return creationResult.fold(
            () => null,
            (createdSocialNetwork) => createdSocialNetwork,
        );
    }
}
